import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { Reveal, SplitLines } from "@/components/Reveal";
import { TESTIMONIALS } from "@/lib/site";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((n) => (n + 1) % TESTIMONIALS.length), 7000);
    return () => clearInterval(t);
  }, []);
  const t = TESTIMONIALS[i];
  return (
    <section id="testimonials" data-testid="testimonials-section" className="bg-[var(--bg-soft)] py-28 lg:py-36">
      <div className="container-x grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal><p className="eyebrow mb-6">Hear Stories</p></Reveal>
          <SplitLines as="h2" inView className="font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.05] tracking-tight text-[var(--navy)]" lines={["From our clients:", <em className="italic text-[var(--mint)]">their experience.</em>]} />
          <div className="mt-10 flex gap-3">
            <button data-testid="testimonial-prev" onClick={() => setI((i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)} className="grid h-12 w-12 place-items-center rounded-full border border-slate-300 text-[var(--navy)] transition-colors hover:bg-[var(--navy)] hover:text-white"><ArrowLeft size={16} /></button>
            <button data-testid="testimonial-next" onClick={() => setI((i + 1) % TESTIMONIALS.length)} className="grid h-12 w-12 place-items-center rounded-full border border-slate-300 text-[var(--navy)] transition-colors hover:bg-[var(--navy)] hover:text-white"><ArrowRight size={16} /></button>
          </div>
        </div>
        <div className="lg:col-span-7 lg:col-start-6 relative min-h-[300px]">
          <Quote className="absolute -top-6 -left-2 h-20 w-20 text-[var(--teal-soft)]" />
          <AnimatePresence mode="wait">
            <motion.blockquote key={i} data-testid="testimonial-quote" initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -24 }} transition={{ duration: 0.6 }} className="relative">
              <p className="font-display text-2xl font-light leading-snug text-[var(--navy)] sm:text-3xl lg:text-4xl">“{t.quote}”</p>
              <footer className="mt-8 flex items-center gap-4">
                <span className="grid h-12 w-12 place-items-center rounded-full bg-[var(--navy)] font-display text-white">{t.name.split(" ").map((w) => w[0]).slice(0, 2).join("")}</span>
                <div><div className="font-semibold text-[var(--navy)]">{t.name}</div><div className="text-xs text-[var(--muted)]">{t.role}</div></div>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
          <div className="mt-10 flex gap-2">{TESTIMONIALS.map((_, k) => <button key={k} data-testid={`testimonial-dot-${k}`} onClick={() => setI(k)} className={`h-1 rounded-full transition-all duration-500 ${k === i ? "w-10 bg-[var(--mint)]" : "w-4 bg-slate-300"}`} />)}</div>
        </div>
      </div>
    </section>
  );
};
